import React from 'react'
import styled from 'styled-components'
import {ReactComponent as VisaLogo} from 'assets/images/card-brands/visa.svg'
import {ReactComponent as MastercardLogo} from 'assets/images/card-brands/mastercard.svg'
import {ReactComponent as AmexLogo} from 'assets/images/card-brands/amex.svg'
import {ReactComponent as DiscoverLogo} from 'assets/images/card-brands/discover.svg'

type CardBrandLogoProps = {
  brand?: string | null
  className?: string
}

const MAIN_CARD_BRANDS = new Set(['visa', 'mastercard', 'amex', 'discover'])

export default function CardBrandLogo(props: CardBrandLogoProps) {
  const displayName = getCardBrandDisplayName(props.brand)

  if (!displayName) {
    return null
  }

  const normalized = normalizeBrand(props.brand)
  const logo = normalized ? getLogo(normalized) : null
  const showLabel = !normalized || !MAIN_CARD_BRANDS.has(normalized)

  return (
    <BrandRow className={props.className}>
      {showLabel && <BrandLabel>{displayName}</BrandLabel>}
      {logo && <LogoWrap>{logo}</LogoWrap>}
    </BrandRow>
  )
}

export function getCardBrandDisplayName(brand?: string | null) {
  if (!brand) {
    return ''
  }

  const normalized = normalizeBrand(brand)

  switch (normalized) {
    case 'visa':
      return 'Visa'
    case 'mastercard':
      return 'Mastercard'
    case 'amex':
      return 'American Express'
    case 'discover':
      return 'Discover'
    default:
      return formatBrandLabel(brand)
  }
}

function normalizeBrand(brand?: string | null) {
  if (!brand) {
    return null
  }

  const normalized = brand.toLowerCase()

  if (normalized === 'american_express') {
    return 'amex'
  }

  return normalized
}

function formatBrandLabel(brand: string) {
  return brand
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase())
}

function getLogo(brand: string) {
  switch (brand) {
    case 'visa':
      return <VisaLogo />
    case 'mastercard':
      return <MastercardLogo />
    case 'amex':
      return <AmexLogo />
    case 'discover':
      return <DiscoverLogo />
    default:
      return null
  }
}

const BrandRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[3]};
`

const BrandLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text.primary};
`

const LogoWrap = styled.span`
  display: inline-flex;
  align-items: center;
  height: 24px;
  flex-shrink: 0;

  svg {
    display: block;
    height: 48px;
    width: auto;
  }
`
